var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_vm._m(0),_c('div',{staticClass:"login-wrapper"},[_c('FormLogin')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-bg"},[_c('div',{staticClass:"bg-circle bg-1"}),_c('div',{staticClass:"bg-circle bg-2"}),_c('div',{staticClass:"bg-circle bg-3"})])
}]

export { render, staticRenderFns }